export enum TbaParameterAmountEnum {
  UnitPrice = 1,
  SalesPrice = 5,
  COGS,
  ResalePrice = 8,
  COGSRelated,
  COGSUnrelated,
}

export enum TbaCalculatedParameterType {
  GrossProfitMarkup = 'Gross Profit Markup',
  GrossProfitMargin = 'Gross Profit Margin'
}
